__turbopack_context__.v({
  "active": "PricesAndTariffs-module__iHS89G__active",
  "container": "PricesAndTariffs-module__iHS89G__container",
  "content": "PricesAndTariffs-module__iHS89G__content",
  "switcher": "PricesAndTariffs-module__iHS89G__switcher",
  "switcherButton": "PricesAndTariffs-module__iHS89G__switcherButton",
  "tariffs": "PricesAndTariffs-module__iHS89G__tariffs",
  "text": "PricesAndTariffs-module__iHS89G__text",
  "title": "PricesAndTariffs-module__iHS89G__title",
});
